import { Col, Row, Table } from "react-materialize";
import styles from "./Partners.module.scss";
import macards from "../Assets/macards.png";
import makomania from "../Assets/makomania.jpg";
import marygames from "../Assets/marygames.png";
import edinstvo from "../Assets/edinstvo.jpg";
import macarcanes from "../Assets/makarcanes.png";

export const Partners = () => {
  return (
    <div className={styles.partners__wrapper}>
      <Row className={styles.partners__cards}>
        <Col m={12} s={12} className="container">
          <Table>
            <tbody>
              <tr>
                <td className={styles.partners__td}>
                  <a href="https://macards.ru/" target="blank">
                    <img
                      className={styles.partners__image}
                      src={macards}
                      alt="macards"
                    ></img>
                  </a>
                </td>
                <td>
                  Уникальный проект, включающий в себя магазин, обучающий
                  контент и издательство
                </td>
              </tr>
              <tr>
                <td className={styles.partners__td}>
                  <a href="https://makomania.ru/" target="blank">
                    <img
                      className={styles.partners__image_small}
                      src={makomania}
                      alt="makomania"
                    ></img>
                  </a>
                </td>
                <td>
                  Обучение работе с метафорическими картами; продажа
                  метафорических карт
                </td>
              </tr>
              <tr>
                <td className={styles.partners__td}>
                  <a href="https://www.marygames.ru/" target="blank">
                    <img
                      className={styles.partners__image}
                      src={marygames}
                      alt="marygames"
                    ></img>
                  </a>
                </td>
                <td>
                  Метафорические карты и трансформационные игры – продажа,
                  обучение, ведущие
                </td>
              </tr>
              <tr>
                <td className={styles.partners__td}>
                  <a href="http://edinstvo-center.ru/" target="blank">
                    <img
                      className={styles.partners__image_small}
                      src={edinstvo}
                      alt="edinstvo"
                    ></img>
                  </a>
                </td>
                <td>Обучение, консультации, супервизии, стажировка, магазин</td>
              </tr>
              <tr>
                <td className={styles.partners__td}>
                  <a href="https://mak.arcanes.ru/" target="blank">
                    <img
                      className={styles.partners__image}
                      src={macarcanes}
                      alt="macarcanes"
                    ></img>
                  </a>
                </td>
                <td>
                  Метафорические ассоциативные карты в работе психолога:
                  продажа, обучение, издательство
                </td>
              </tr>
            </tbody>
          </Table>
        </Col>
      </Row>
    </div>
  );
};
